export default __webpack_public_path__ + "static/media/kfc.e61e80df.png";